import { render, staticRenderFns } from "./SessionObjectCardMultipleAnswer.vue?vue&type=template&id=76149030&scoped=true&"
import script from "./SessionObjectCardMultipleAnswer.vue?vue&type=script&lang=js&"
export * from "./SessionObjectCardMultipleAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76149030",
  null
  
)

export default component.exports